module.exports = __webpack_public_path__ + "static/media/logo-2-white.09359eab.png";